import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrHostResponseTimeBucket.ts
var t = () => e("hostResponseTimeBucket");
//#endregion
export { t as useTrHostResponseTimeBucket };
